<fc-general-modal
  [baseId]="baseId"
  [form]="form"
  [fcModalItemContext]="fcModalItemContext"
  (saveForm)="save()"
  (cancelForm)="onCancel()"
>
  <div [formGroup]="form">
    <div class="flex-row-generic">
      <!-- Pharmacy Name Control start -->
      <div class="flex-item-three-columns">
        <div class="form-group">
          <label
            for="{{ baseId }}-pharmacy-name"
            translate
          >Pharmacy Name</label>
          <input
            id="{{ baseId }}-pharmacy-name"
            class="form-control"
            [ngClass]="{ error: showErrors(pharmacyNameControl, isSubmitted), 'required': isRequired(pharmacyNameControl) }"
            type="text"
            [maxlength]="fcListValidation.validations.Name.MaxLength"
            formControlName="name"
          />
          <div
            *ngIf="showErrors(pharmacyNameControl, isSubmitted)"
            id="{{ baseId }}-warning-text-name"
            class="incorrect-input"
            translate
          >
            {{ pharmacyNameControl.errors | fcListValidation : 'Pharmacy Name' }}
          </div>
        </div>
      </div>
      <!-- Pharmacy Name Control end -->

      <!-- Master Pharmacy Control start -->
      <div class="flex-item-three-columns form-group">
        <label for="{{ baseId }}-master-pharmacy">Master Pharmacy</label>
        <ap-findcontrol
          id="{{ baseId }}-master-pharmacy"
          [baseId]="baseId"
          [apFormGroup]="form"
          controlName="masterPharmacyControl"
          [findControlId]="findControlIdService.ViewMasterPharmacy"
          [(selectedPks)]="selectedMasterPharmacyControlPks"
          [placeHolder]=""
          (chipsChange)="onMasterPharmacyDataPopulate($event)"
          [disabled]="false"
          [singleSelect]="true"
          findControlDisplayName="Find Master Pharmacy List"
          [required]="getFindControlValidation('MasterPharmacyUid')"
          (dirty)="masterPharmacyControl.markAsDirty()"
          [formGroupSubmitted]="isSubmitted"
          [form]="form"
          (chipValueChanged)="onMasterPharmacyValueChanged($event)"
        >
        </ap-findcontrol>
      </div>
      <!-- Master Pharmacy Control end -->

      <!-- NPI Control start -->
      <div class="flex-item-three-columns">
        <div class="form-group">
          <label
            for="{{ baseId }}-npi"
            translate
          >NPI</label>
          <input
            id="{{ baseId }}-npi"
            class="form-control"
            [ngClass]="{ error: showErrors(npiControl, isSubmitted), 'required': isRequired(npiControl) }"
            type="text"
            formControlName="npi"
          />
          <div
            *ngIf="showErrors(npiControl, isSubmitted)"
            id="{{ baseId }}-warning-text-npi"
            class="incorrect-input"
            translate
          >
            {{ npiControl.errors | fcListValidation : 'NPI' }}
          </div>
        </div>
      </div>
      <!-- NPI Control end -->
    </div>
    <div class="flex-row-generic">
      <!-- NCPDPID Control start -->
      <div class="flex-item-three-columns">
        <div class="form-group">
          <label
            for="{{ baseId }}-ncpdpid"
            translate
          >NCPDPID</label>
          <input
            id="{{ baseId }}-ncpdpid"
            class="form-control"
            [ngClass]="{ error: showErrors(ncpdpidControl, isSubmitted), 'required': isRequired(ncpdpidControl) }"
            type="text"
            formControlName="ncpdpid"
          />
          <div
            *ngIf="showErrors(ncpdpidControl, isSubmitted)"
            id="{{ baseId }}-warning-text-id"
            class="incorrect-input"
            translate
          >
            {{ ncpdpidControl.errors | fcListValidation : 'ID' }}
          </div>
        </div>
      </div>
      <!-- NCPDPID Control end -->
    </div>

    <hr />
    <h4
      id="{{ baseId }}-address-subtitle"
      translate
    >Address</h4>

    <!-- Address Group start -->
    <fc-address-list
      [baseId]="baseId + 'address'"
      [form]="addressGroup"
      [listItem]="listItem.Address"
      [isSubmitted]="isSubmitted"
      [itemContext]="fcModalItemContext"
      (areaCode)="onSetAreaCode($event)"
    ></fc-address-list>
    <!-- Address Group end -->

    <hr />
    <h4
      id="{{ baseId }}-contact-information-subtitle"
      translate
    >Contact Information</h4>

    <!--     Contact Information Group start -->
    <fc-phone-number-list
      [baseId]="baseId"
      [form]="phoneOneGroup"
      [listItem]="listItem.Phone1"
      [isSubmitted]="isSubmitted"
      [itemContext]="fcModalItemContext"
      [index]="1"
    ></fc-phone-number-list>
    <fc-phone-number-list
      [baseId]="baseId"
      [form]="phoneTwoGroup"
      [listItem]="listItem.Phone2"
      [isSubmitted]="isSubmitted"
      [itemContext]="fcModalItemContext"
      [index]="2"
    ></fc-phone-number-list>
    <fc-phone-number-list
      [baseId]="baseId"
      [form]="phoneThreeGroup"
      [listItem]="listItem.Phone3"
      [isSubmitted]="isSubmitted"
      [itemContext]="fcModalItemContext"
      [index]="3"
    ></fc-phone-number-list>
    <!-- Contact Information Group end -->

    <!-- Inactive checkbox start -->
    <div class="checkbox-group">
      <mat-checkbox
        id="{{ baseId }}-inactive-checkbox"
        formControlName="inactive"
        translate
      > Inactive </mat-checkbox>
    </div>
    <!-- Inactive checkbox end -->
  </div>
</fc-general-modal>
